<!-- <div class="container margin-top-20">
  <div class="row">
    <div class="col-lg-4 col-md-5 col-sm-12">
      <div class="user-profile-box">
        <div class="header clearfix">
          <h3>{{userFullName}}</h3>
          <div class="profile-img">
            <img [src]="PictureURL" alt="UserName" class="img-fluid" />
            <div class="overlay">
                <label class="icon" for="picUploader">
                  <i class="fa fa-camera fa-lg"></i>
                </label>
                <input id="picUploader" #file type="file" accept="image/x-png,image/gif,image/jpeg" name="image" [(ngModel)]="Image"  #profileImageControl="ngModel" (change)="preview(file.files)"/>
            </div>
          </div>
        </div>
        <div class="detail clearfix">
          <ul class="my-account-nav">
            <li class="sub-nav-title">Manage Account</li>
            <li><a [routerLink]="'/account/profile'" class="current"><i class="sl sl-icon-user"></i> My Profile</a></li>
          </ul>
          <ul class="my-account-nav">
            <li class="sub-nav-title">Manage Listings</li>
            <li><a [routerLink]="'/account/properties'"><i class="sl sl-icon-docs"></i> My Properties</a></li>
            <li><a [routerLink]="'/property/submit'"><i class="sl sl-icon-action-redo"></i> Submit New Property</a></li>
          </ul>
          <ul class="my-account-nav no-border-bottom">
            <li><a [routerLink]="'/account/change-password'"><i class="sl sl-icon-lock"></i> Change Password</a></li>
            <li><a [routerLink]="'/'" (click)="Logout()"><i class="sl sl-icon-power"></i> Log Out</a></li>
          </ul>
        </div>
      </div>
    </div> -->








    <div class="container margin-top-20">
      <div class="row">
        <div class="col-lg-4 col-md-5 col-sm-12">
          <div class="user-profile-box">
            <div class="header clearfix">
              <h3>{{userFullName}}</h3>
              <img [src]="PictureURL" alt="UserName" class="img-fluid profile-img">
              <div class="profile-img">
                <div class="overlay">
                    <label class="icon" for="picUploader">
                      <i class="fa fa-camera fa-lg"></i>
                    </label>
                    <input id="picUploader" #file type="file" accept="image/x-png,image/gif,image/jpeg" name="image" [(ngModel)]="Image"  #profileImageControl="ngModel" (change)="preview(file.files)"/>
                </div>
              </div>
            </div>
            <div class="detail clearfix">
              <ul class="my-account-nav">
                <li class="sub-nav-title">Manage Account</li>
                <li><a [routerLink]="'/account/profile'"><i class="sl sl-icon-user"></i> My Profile  </a> > <a [routerLink]="'/account/profile/edit'" class="current"> Edit</a></li>
              </ul>
              <ul class="my-account-nav">
                <li class="sub-nav-title">Manage Listings</li>
                <li><a [routerLink]="'/account/properties'"><i class="sl sl-icon-docs"></i> My Properties</a></li>
                <li><a [routerLink]="'/property/submit'"><i class="sl sl-icon-action-redo"></i> Submit New Property</a></li>
              </ul>
              <ul class="my-account-nav no-border-bottom">
                <li><a [routerLink]="'/account/change-password'"><i class="sl sl-icon-lock"></i> Change Password</a></li>
                <li><a [routerLink]="'/'" (click)="Logout()"><i class="sl sl-icon-power"></i> Log Out</a></li>
              </ul>
            </div>
          </div>
        </div>
    <div class="col-lg-8 col-md-7 col-sm-12">
      <div class="notification notice">
        <div class="form-group pl-10">
          <h3>Account Information </h3>
        </div>
      </div>
      <form (ngSubmit)="Submit()" class="submit-section" #updateProfileForm="ngForm">
        <div class="row margin-bottom-10">
          <div class="col-md-6">
            <div class="form-group" [class.has-error]="firstNameControl.invalid && firstNameControl.touched"
              [class.has-success]="firstNameControl.valid">
              <label for="firstName" class="control-label">First Name:<i class="fa fa-asterisk"></i></label>
              <input type="text" maxlength="35" name="firstName" class="form-control input-text" [(ngModel)]="FirstName" required
                #firstNameControl="ngModel" />
              <div class="notification error" *ngIf="firstNameControl.invalid && firstNameControl.touched">
                <p>First name is required</p>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group" [class.has-error]="lastNameControl.invalid && lastNameControl.touched"
              [class.has-success]="lastNameControl.valid">
              <label for="lastName" class="control-label">Last Name:<i class="fa fa-asterisk"></i></label>
              <input type="text" maxlength="35" name="lastName" class="form-control input-text" [(ngModel)]="LastName" required
                #lastNameControl="ngModel" />
              <div class="notification error" *ngIf="lastNameControl.invalid && lastNameControl.touched">
                <p>Last name is required</p>
              </div>
            </div>
          </div>
        </div>
        <div class="row margin-bottom-10">
          <div class="col-md-6">
            <div class="form-group" [class.has-error]="userNameControl.invalid && userNameControl.touched"
              [class.has-success]="userNameControl.valid">
              <label for="userName" class="control-label">User Name:<i class="fa fa-asterisk"></i></label>
              <input type="text" name="userName" disabled class="form-control input-text" [(ngModel)]="UserName"
                required #userNameControl="ngModel" />
              <div class="notification error" *ngIf="userNameControl.invalid && userNameControl.touched">
                <p>User name is required</p>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group" [class.has-error]="emailAddressControl.invalid && emailAddressControl.touched"
              [class.has-success]="emailAddressControl.valid">
              <label for="emailAddress" class="control-label">Email Address:<i class="fa fa-asterisk"></i></label>
              <input type="text" name="emailAddress" disabled class="form-control input-text" [(ngModel)]="EmailAddress"
                required #emailAddressControl="ngModel" />
              <div class="notification error" *ngIf="emailAddressControl.invalid && emailAddressControl.touched">
                <p>Email address is required</p>
              </div>
            </div>
          </div>
        </div>
        <div class="row margin-bottom-10">
          <div class="col-md-6">
            <div class="form-group" [class.has-error]="phoneControl.invalid && phoneControl.touched"
              [class.has-success]="phoneControl.valid">
              <label for="phone" class="control-label">Phone Number:<i class="fa fa-asterisk"></i></label>
              <input type="text"  maxlength="16" (keypress)="numberOnly($event)" onpaste="return false;" ondrag="return false;" ondrop="return false;" name="phone" class="form-control input-text" [(ngModel)]="Phone" required
                #phoneControl="ngModel" />
              <div class="notification error" *ngIf="phoneControl.invalid && phoneControl.touched">
                <p>Phone number is required</p>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group" [class.has-error]="addressControl.invalid && addressControl.touched"
              [class.has-success]="addressControl.valid">
              <label for="address" class="control-label">Address:<i class="fa fa-asterisk"></i></label>
              <input type="text" maxlength="500" name="address" class="form-control input-text" [(ngModel)]="Address" required
                #addressControl="ngModel" />
              <div class="notification error" *ngIf="addressControl.invalid && addressControl.touched">
                <p>Address is required</p>
              </div>
            </div>
          </div>
        </div>
        <div class="row margin-bottom-10">
          <div class="col-md-12">
            <div class="form-group" [class.has-error]="aboutControl.invalid && aboutControl.touched"
              [class.has-success]="aboutControl.valid">
              <label for="about" class="control-label">About Me:<i class="fa fa-asterisk"></i></label>
              <textarea class="input-text" [(ngModel)]="About" name="about" required #aboutControl="ngModel" cols="30"
                rows="10"></textarea>
              <div class="notification error" *ngIf="aboutControl.invalid && aboutControl.touched">
                <p>About me is required</p>
              </div>
            </div>
          </div>
        </div>

        <div class="row margin-bottom-25">
          <div class="col-md-12">
            <input type="submit" class="button submit"  [disabled]="updateProfileForm.invalid"  value="Save Changes" />
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
